/** Tải blob Excel/PDF về máy (dùng chung cho xuất file từ API).
 *
 *  P2 (fix 2026-06-27): Cần append anchor vào DOM trước khi `click()` + delay cleanup
 *  (~100ms). Nếu `anchor.remove()` + `URL.revokeObjectURL()` NGAY sau `click()` sẽ cancel
 *  in-flight download trên Chrome/Edge (đặc biệt Playwright `page.waitForEvent('download')`
 *  timeout vì event không kịp fire trước khi DOM cleanup). Pattern tham khảo:
 *  https://stackoverflow.com/q/49592058 (Stack Overflow 49592058).
 *
 *  Trade-off: anchor trong DOM 100ms với `display: none` → user không thấy nhưng browser
 *  vẫn có thể hoàn tất download initiation. SetTimeout thay vì `requestAnimationFrame`
 *  vì cần chờ browser xử lý xong click → trigger download. */
export const downloadBlobAsFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.style.display = 'none'
  // CRITICAL: append to body — một số browser (Chrome headless) cần anchor in DOM
  // during click() để trigger native download event.
  document.body.appendChild(anchor)
  anchor.click()
  // Delay cleanup để browser finish initiate download (đặc biệt quan trọng với Playwright).
  setTimeout(() => {
    if (anchor.parentNode) anchor.parentNode.removeChild(anchor)
    window.URL.revokeObjectURL(url)
  }, 100)
}
